import { useEffect, useState } from "react";
import "./ToggleButton.scss";

const ToggleButton = ({
  id,
  label,
  onChange,
  readOnly,
  value = false,
  dataTestId,
}) => {
  const [enabled, setEnabled] = useState(value);

  useEffect(() => {
    setEnabled(value);
  }, [value]);

  return (
    <label
      className={`toggle ${readOnly ? "" : "cursor"}`}
      id={`toggle-button-${id}`}
    >
      <input
        className="toggle-checkbox"
        type="checkbox"
        onChange={() => {
          setEnabled(!enabled);
          onChange(!enabled);
        }}
        disabled={readOnly}
        checked={enabled}
        id={`toggle-switch-${id}`}
        data-testid={dataTestId}
      />
      <div className="toggle-switch"></div>
      <span className={`toggle-label ${enabled ? "toggle-enabled" : ""}`}>
        {label}
      </span>
    </label>
  );
};

export default ToggleButton;
